const o = "_modalContainer_264wt_1", a = "_outSideModal_264wt_5", t = "_modal_264wt_1", n = "_smallModal_264wt_13", _ = "_mediumModal_264wt_17", l = "_largeModal_264wt_21", c = "_modalHeader_264wt_33", d = "_modalFooter_264wt_37", e = "_mainFooterActions_264wt_41", s = "_footerFullWidth_264wt_45", r = "_footer3rdActions_264wt_52", i = "_fancy_264wt_56", m = "_infoFancy_264wt_60", F = "_successFancy_264wt_64", w = "_warningFancy_264wt_68", y = "_neutralFancy_264wt_72", u = "_dangerFancy_264wt_76", M = {
  modalContainer: o,
  outSideModal: a,
  modal: t,
  smallModal: n,
  mediumModal: _,
  largeModal: l,
  "x-largeModal": "_x-largeModal_264wt_25",
  "xx-largeModal": "_xx-largeModal_264wt_29",
  modalHeader: c,
  modalFooter: d,
  mainFooterActions: e,
  footerFullWidth: s,
  footer3rdActions: r,
  fancy: i,
  infoFancy: m,
  successFancy: F,
  warningFancy: w,
  neutralFancy: y,
  dangerFancy: u
};
export {
  u as dangerFancy,
  M as default,
  i as fancy,
  r as footer3rdActions,
  s as footerFullWidth,
  m as infoFancy,
  l as largeModal,
  e as mainFooterActions,
  _ as mediumModal,
  t as modal,
  o as modalContainer,
  d as modalFooter,
  c as modalHeader,
  y as neutralFancy,
  a as outSideModal,
  n as smallModal,
  F as successFancy,
  w as warningFancy
};
//# sourceMappingURL=Modal.module.scss.js.map
